import { HiOutlineDownload } from "react-icons/hi";

const DownloadIconLink = ({ url, size = 18 }) => {
  if (!url) return null;

  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      <HiOutlineDownload size={size} />
    </a>
  );
};

export default DownloadIconLink;
